<style lang='less' scoped>
.main {
  padding: 10px;
  box-sizing: border-box;
  background: #f3f3f3;
  .create-new {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: 1000px;
    overflow: auto;
    padding: 20px 30px;
    box-sizing: border-box;
    z-index: 9999;
    .header {
      width: 100%;
      height: 48px;
      display: flex;
      line-height: 48px;
      font-weight: 600;
      .back {
        width: 72px;
        height: 48px;
      }
      .message {
        width: 98px;
        height: 48px;
        text-align: center;
        line-height: 36px;
      }
    }
    .content {
      position: relative;
      width: 100%;
      height: 500px;
      background: #fff;
      .cutBtn {
        width: 100%;
        padding: 12px 0;
        box-sizing: border-box;
      }
      .uploadMyFile {
        width: 280px;
      }
      .message {
        width: 100%;
        height: 30px;
        color: #949494;
        line-height: 30px;
      }
      .cropper-content {
        .cropper {
          width: 750px;
          height: 400px;
        }
      }
    }
  }
}
</style>
<template>
  <div class="main">
    <!-- 创建banner -->
    <div class="create-new">
      <div class="header">
        <Button type="primary" style="height: 36px;">
          <Icon type="ios-arrow-back" />返回
        </Button>
        <div class="message">banner创建</div>
      </div>
      <div class="content">
        <Upload
          type="drag"
          class="uploadMyFile"
          show-upload-list
          :before-upload="AddBanner"
          accept=".jpg, .jpeg, .png"
          action
          @on-remove="RemoveBanner"
        >
          <div style="padding: 20px 0;width: 280px !important;">
            <Icon
              type="ios-cloud-upload"
              on-preview="true"
              size="52"
              style="color: #3399ff;width: 280px !important;"
            />
            <p>单击或拖动文件以上传</p>
          </div>
        </Upload>
        <div class="message">只能上传jpg/png文件，且不超过500kb</div>
        <a :href="needUrl" class="message">{{needUrl}}</a>
        <div v-for="(item,index) in bannerPicList" :key="index" class="message">{{item.name}}</div>
        <!-- 剪裁部分 -->
        <div class="cropper-content">
          <div class="cropper" style="text-align: center">
            <vueCropper
              ref="cropperNew"
              :img="option.img"
              :outputSize="option.outputSize"
              :outputType="option.outputType"
              :info="option.info"
              :canScale="option.canScale"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
            />
          </div>
        </div>
        <div class="cutBtn">
          <Button @click="CutBanner" type="primary">剪裁</Button>
        </div>
        <div style="margin-top: 10px" v-show="bannerLink">
          <Input
            v-model="bannerUrl"
            placeholder="请输入banner链接地址"
            style="width: 300px;height: 42px;"
          />
        </div>
        <Button v-show="bannerLink" @click="saveBanner" type="primary">保存</Button>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import brandApi from '@/lib/api/brand'
import utilsTool from '@lib/utils'
export default {
  name: '',
  data() {
    return {
      bannerPicList: [],
      bannerUrlList: [],
      bannerLink: false, //
      bannerUrl: '', // banner链接跳转地址
      needUrl: '', // 剪裁之后生成的banner的图片地址
      // 裁剪组件的基础配置option
      option: {
        name: '',
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 450, // 默认生成截图框宽度
        autoCropHeight: 240, // 默认生成截图框高度
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [7.5, 4] // 截图框的宽高比例
      },
      isShowCropper: false, // 是否显示截图框
      fileUpload: null,
      fileinfo: {},
      form: {},
      templateTypeOne: '', // 生成的启动页图片1地址
      templateTypeTwo: '' // 生成启动页图片2地址
    }
  },
  created() {

  },
  methods: {
    AddBanner(file) {
      console.log(file)
      this.option.name = file.name
      const fileReader = new FileReader()
      const that = this
      fileReader.onload = function(e) {
        // target.result 该属性表示目标对象的DataURL
        that.option.img = e.target.result
      }
      fileReader.readAsDataURL(file)
      return false
    },
    // 剪裁图片
    CutBanner() {
      // 获取cropper的截图的base64 数据
      this.$refs.cropperNew.getCropData(data => {
        console.log(data)
        this.fileinfo.url = data
        this.isShowCropper = false
        // 先将显示图片地址清空，防止重复显示
        this.needUrl = ''
        this.bannerPicList = []
        this.bannerUrlList = []
        // 将剪裁后base64的图片转化为file格式
        const file = this.ConvertBase64UrlToBlob(data)
        // file.name = this.fileUpload.name
        // 将剪裁后的图片执行上传
        this.UploadBanner(file)
      })
    },
    // 将base64的图片转换为file文件
    ConvertBase64UrlToBlob(urlData) {
      const arr = urlData.split(',')
      const data = window.atob(arr[1])
      const mime = arr[0].match(/:(.*?);/)[1]
      const ia = new Uint8Array(data.length)
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i)
      }
      const blob = new Blob([ia], { type: mime })
      return new window.File([blob], this.option.name, { type: mime })
    },
    AddNew() {
      this.myHomePage = false
      this.createNew = true
      this.editBanner = false
      this.option.img = ''
      this.$refs.cropperNew.refresh()
      this.needUrl = ''
      this.bannerUrl = ''
      this.bannerPicList = []
      this.bannerUrlList = []
    },
    UploadBanner(file) {
      utilsTool.UploadPic({
        file,
        success: (res) => {
          this.bannerPicList.push(file)
          console.log(this.bannerPicList)
          this.bannerUrlList.push(res)
          console.log(this.bannerUrlList)
          this.linkUrl = this.bannerUrlList[0]
          this.needUrl = this.linkUrl.url
          console.log(this.needUrl)
          this.$Message.info('剪裁成功')
          this.bannerLink = true
        },
        fail: (err) => {
          console.log(err)
        }
      })
    },
    RemoveBanner(file, fileList) {
      console.log(file, fileList)
    }
  }
}
</script>
